import Keycloak from "keycloak-js";

// Runtime configuration (loaded from public/config.js at runtime)
// Falls back to build-time env vars, then defaults
const config = globalThis.__RUNTIME_CONFIG__ || {};

const KEYCLOAK_URL = config.KEYCLOAK_URL || import.meta.env.VITE_KEYCLOAK_URL || "http://localhost:8080";
const KEYCLOAK_REALM = config.KEYCLOAK_REALM || import.meta.env.VITE_KEYCLOAK_REALM || "LePrestigeHall";
const KEYCLOAK_CLIENT_ID = config.KEYCLOAK_CLIENT_ID || import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "le-prestige-hall-ui";

const keycloak = new Keycloak({
  url: KEYCLOAK_URL,
  realm: KEYCLOAK_REALM,
  clientId: KEYCLOAK_CLIENT_ID,
  checkLoginIframe: false,
});

export default keycloak;
